<template>
  <div class="product-grid" id="product-grid">
    <product-item v-for="product in products" :key="product.id" :product="product" />

    <div :class="['newsletter-grid-item', { wide: products.length % 2 === 0 }]">
      <p class="nord text-center">
        Subscribe here to be notified of restocks and new items, and to receive other commercial emails from us about
        our products and services and those of our partners.
      </p>
      <airtable-subscribe />
    </div>
  </div>
</template>

<script>
import { getCollection } from '@/lib/shopify-utils'
import ProductItem from '@/components/ProductItem.vue'
import AirtableSubscribe from '@/components/AirtableSubscribe'

export default {
  name: 'ProductGrid',
  components: {
    ProductItem,
    AirtableSubscribe,
  },
  props: {
    collectionId: String,
  },
  data() {
    return {
      products: [],
    }
  },
  async mounted() {
    if (this.collectionId) {
      // un base64 encode the collection id
      const decodedCollectionId = atob(this.collectionId)

      const collection = await getCollection({ collectionId: decodedCollectionId })

      if (collection.data) {
        this.products = collection.data.collection.products.nodes
      }
    }
  },
}
</script>

<style scoped>
.newsletter-grid-item {
  border: 1px dashed #fff;
  border-radius: var(--br);
  padding: 6rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.newsletter-grid-item > * + * {
  margin-top: 3rem;
}

.newsletter-grid-item.wide {
  grid-column: 1 / -1;
  padding: 6rem 22%;
}

@media (max-width: 1000px) {
  .newsletter-grid-item.wide {
    padding: 6rem;
  }
}
</style>
